import { Image, Text, View } from '@react-pdf/renderer';

import { Contract } from '@/types/ContractType';
import { styles } from '../style';

const Signature = ({ contract }: { contract: Contract }) => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Signature</Text>

      <View style={styles.signatureSection}>
        <View style={styles.signatureColumn}>
          <Text style={styles.signatureLabel}>Buyer</Text>

          <View style={styles.signatureLine}>
            <Text style={styles.text}>Signature: </Text>
            <Image
              src={contract?.buyerSign?.signature || ''}
              style={styles.image}
            />
          </View>

          <View style={styles.signatureLine}>
            <Text style={styles.text}>
              Date:{' '}
              {contract?.buyerSign?.signedAt
                ? new Date(contract.buyerSign.signedAt).toLocaleDateString()
                : 'N/A'}
            </Text>
          </View>
        </View>

        <View style={styles.signatureColumn}>
          <Text style={styles.signatureLabel}>Seller</Text>

          <View style={styles.signatureLine}>
            <Text style={styles.text}>Signature: </Text>
            <Image
              src={contract?.sellerSign?.signature || ''}
              style={styles.image}
            />
          </View>

          <View style={styles.signatureLine}>
            <Text style={styles.text}>
              Date:{' '}
              {contract?.sellerSign?.signedAt
                ? new Date(contract.sellerSign.signedAt).toLocaleDateString()
                : 'N/A'}
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
};

export default Signature;
